import React from "react";
import styles from "../css/notFound.module.css";
function NotFound(props) {
	return <div className={styles.notFound_wrapper}></div>;
}

export default NotFound;
